module.exports = __webpack_public_path__ + "img/map_5.53728a1c.jpg";